import React from 'react'
import { NavLink } from 'react-router-dom';
import Header from '../Components/Header'
import Footer from '../Components/Footer'
import { createEnquiry } from '../api/auth/authService';
//import { PreLoginUUID,PostLoginUUID,getToken,saveToken } from '../utils/auth';

function Product() {
    const [values, setValues] = React.useState({
        name: "",
        email: "",
        phone: "",
        enquiryfor: "",
        address: "",
        message: "",
        date: ""

    });

    const handleChanges = (e) => {
        const { name, value } = e.target;
        setValues({
            ...values,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const currentDate = new Date().toISOString().split("T")[0];

        const payload = {
            ...values,
            date: currentDate
        };
        try {
            const response = await createEnquiry(payload);
            console.log(response.data);
            alert("Message sent successfully!");
            setValues({
                name: "",
                email: "",
                phone: "",
                enquiryfor: "",
                address: "",
                message: "",
                date: ""

            });
        } catch (error) {
            console.error("There was an error sending the message!", error);
            alert("Message not sent");
        }
    };
    return (
        <div>
            <Header />
            <div className="breadcrumbs overlay">
                <div className="container">
                    <div className="bread-inner">
                        <div className="row">
                            <div className="col-12">
                                <h2> Other Product</h2>
                                <ul className="bread-list">
                                    <li><NavLink to='/'>Pricing</NavLink></li>
                                    <li><i className="icofont-simple-right" /></li>
                                    <li className="active">Other Product</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section className="contact-us section">
                <div className="container">
                    <div className="inner">
                        <div className="row">
                            <div className="col-lg-6 col-md-12 ">
                                <div className="appointment-image">
                                    <img src="img/blog4.jpg" alt="#" />
                                </div>
                            </div>
                            {/* Contact Form */}
                            <div className="col-lg-6 col-12  d-flex" >
                                <div className="contact-us-form">
                                    <h2>Contact Our Other product </h2>
                                    {/* <p>If you have any questions please feel free to contact with us.</p> */}
                                    <form className="form" onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <input type="text" name="name" placeholder="Name" onChange={handleChanges}
                                                        value={values.name}
                                                        required />
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <input type="email" name="email" placeholder="Email" onChange={handleChanges}
                                                        value={values.email}
                                                        required />
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <input type="text" name="phone" placeholder="Phone" onChange={handleChanges}
                                                        value={values.phone}
                                                        required />
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <input type="text" name="enquiryfor" placeholder="Enquiry For" onChange={handleChanges}
                                                        value={values.enquiryfor}
                                                        required />
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="form-group">
                                                    <input type="text" name="address" placeholder="Address" onChange={handleChanges}
                                                        value={values.address}
                                                        required />
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="form-group">
                                                    <textarea name="message" placeholder="Your Message" onChange={handleChanges}
                                                        value={values.message}
                                                        required defaultValue={""} />
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div className="form-group login-btn">
                                                    <button className="btn" type="submit">Send</button>
                                                </div>

                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>

                        </div>

                    </div>


                </div>
            </section>
            <Footer />
        </div>
    )
}

export default Product
